export default function Cellempty() {
    return (
        <div className="EmptyCellBox"><span className="Cell_text"></span></div>
    );
}
